<div class="fx-column">
  <span class="page-title">{{'HOME.TITLE' | translate:user}}</span>
  <span class="page-subtitle">{{'HOME.SUBTITLE' | translate:user}}</span>
</div>
<mat-divider class="mv-20"></mat-divider>
<app-dashboard *ngIf="isManagerOrAbove"></app-dashboard>
<!-- Operators use the country operator dashboard, without the map -->
<app-dashboard-country-operator *ngIf="isCountryOperator || isOperator"></app-dashboard-country-operator>
<app-dashboard-case-operator *ngIf="isCaseOperator"></app-dashboard-case-operator>